import React from 'react';
import moment from 'moment';
import { toArray } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    EBON_ACTIVATION_TYPE_ONLINE,
    EBON_ACTIVATION_TYPE_OFFLINE,
    EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE
} from '../../../constants/ebon';
import { STATIC_ROOT } from '../../../constants';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';
import { MOMENTJS_DATE_FORMAT } from '../../../constants/moment';
import {
    MODAL_TYPE_LOGGED_OUT,
    MODAL_TYPE_LIMITED_ACCESS
} from '../../../services/modal/constants';

import { showModal } from '../../../services/modal/actions';

import { getPartner, getEbonPartner } from '../../../services/partner/selector';
import { getCoupons } from '../../../services/coupon/selector';
import { isLimitedMember } from '../../../services/authentication/selector';

import {
    getInstertitielCashbackUrl,
    displayableCashback,
    hasCashback,
    hasCashbackOffline,
    hasEbon,
    hasEbonCashback
} from '../../../services/partner/utils';

import SvgComponent from '../../SvgComponent';
import CouponComponent from '../../coupon/CouponComponent';
import LinkButtonComponent from '../../button/LinkButtonComponent';
import PartnerBlockHorizontalComponent from '../../partner/PartnerBlockHorizontalComponent';

const DELAI_VALIDATION_DEFAULT = 15;

class HeaderComponent extends React.Component {
    // membre limité (abonnement expiré) : l'offre est bloquée, modale d'information
    guardLimitedClick = event => {
        const { isLimited, showModal } = this.props;
        if (isLimited) {
            event.preventDefault();
            showModal(MODAL_TYPE_LIMITED_ACCESS);
            return false;
        }
    };

    guardOfferClick = event => {
        const { isAuthenticated, showModal } = this.props;
        if (!isAuthenticated) {
            event.preventDefault();
            showModal(MODAL_TYPE_LOGGED_OUT);
            return false;
        }
        return this.guardLimitedClick(event);
    };

    // Libellé de l'offre la plus haute parmi les remises actives : % le plus
    // fort, puis € le plus fort (les libellés Qwertys portent déjà le montant).
    getHighestDiscountLabel = () => {
        const { discounts, isOffline } = this.props;

        const highest = (discounts || [])
            .filter(d => (isOffline ? d.offlineActive : d.onlineActive))
            .sort((d1, d2) => {
                const c1 = d1.cashback || {};
                const c2 = d2.cashback || {};
                return (c2.percent || 0) - (c1.percent || 0) || (c2.fixed || 0) - (c1.fixed || 0);
            })[0];

        return highest && highest.label;
    };

    // certains libellés Qwertys portent déjà le "Jusqu'à" : on ne le préfixe pas une
    // seconde fois (comparaison insensible à la casse et à l'apostrophe typographique)
    labelContainsJusqua = qwertysLabel => {
        const normalize = str => str.toLowerCase().replace(/’/g, "'");
        return normalize(qwertysLabel).includes(normalize(this.props.i18nPartner.jusqua));
    };

    getAvailability = e => {
        const { i18nPage } = this.props;

        if (e.activationType === EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE) {
            return i18nPage.EBON_TYPE_ON_OFF;
        } else if (e.activationType === EBON_ACTIVATION_TYPE_ONLINE) {
            return i18nPage.EBON_TYPE_ON;
        } else if (e.activationType === EBON_ACTIVATION_TYPE_OFFLINE) {
            return i18nPage.EBON_TYPE_OFF;
        }
        return null;
    };

    renderEbonCashbackCumulable = () => {
        const { i18nPartner, partner, ebonPartner } = this.props;

        if (!ebonPartner.ebonDiscount.cumulativeWithCashbackDiscount || !hasCashback(partner)) {
            return null;
        }

        const discount = partner.mostDisplayableDiscountOnline;
        let onlineCashback = partner.isMultiDiscount ? `${i18nPartner.jusqua} ` : '';
        onlineCashback += `${displayableCashback(discount.percent, discount.fixed)} `;
        return (
            <p className="ebonCumul">
                {convertHtmlToReactDomWithParams(
                    i18nPartner.EBON_CASHBACK_CUMULABLE,
                    onlineCashback
                )}
            </p>
        );
    };

    renderOnlineEbonCumulable = () => {
        const { i18nPartner, partner, ebonPartner } = this.props;

        if (
            !hasEbonCashback(ebonPartner) ||
            !ebonPartner.ebonDiscount.cumulativeWithCashbackDiscount ||
            !hasCashback(partner)
        ) {
            return null;
        }

        const { percent, fixed } = ebonPartner.ebonDiscount.cashback;
        const ebonCashback = `${displayableCashback(percent.value, fixed.value)} `;
        return (
            <p className="ebonCumul">
                {convertHtmlToReactDomWithParams(
                    i18nPartner.CASHBACK_EBON_CUMULABLE,
                    ebonCashback
                )}
            </p>
        );
    };

    renderCashback = () => {
        const { i18nPartner, partner, isOffline, discounts, isEbon, ebonPartner, isQwertys } =
            this.props;
        if (
            (partner &&
                ((!isOffline && hasCashback(partner)) ||
                    (isOffline && hasCashbackOffline(partner)))) ||
            (isEbon && hasEbon(ebonPartner))
        ) {
            const { percent, fixed, initialPercent, initialFixed, label } = isOffline
                ? partner.mostDisplayableDiscountOffline
                : isEbon && ebonPartner && ebonPartner.ebonDiscount
                ? {
                      fixed: ebonPartner.ebonDiscount.cashback.fixed.value,
                      percent: ebonPartner.ebonDiscount.cashback.percent.value,
                      initialPercent: ebonPartner.ebonDiscount.cashback.percent.initialValue
                  }
                : partner.mostDisplayableDiscountOnline;
            const initialCashback = displayableCashback(initialPercent, initialFixed);
            const isMultiDiscount =
                discounts &&
                !isEbon &&
                discounts.filter(d => (isOffline ? d.offlineActive : d.onlineActive)).length > 1;

            if (isQwertys) {
                // Le libellé de l'offre la plus haute remplace le "jusqu'à X%" ;
                // repli sur la valeur brute si aucune offre n'a de libellé.
                const qwertysLabel = label || this.getHighestDiscountLabel();

                return (
                    <div className="cashback">
                        {qwertysLabel ? (
                            <React.Fragment>
                                <span className="upTo">
                                    {isMultiDiscount &&
                                        !this.labelContainsJusqua(qwertysLabel) &&
                                        `${i18nPartner.jusqua} `}
                                </span>
                                <span className="value qwertys-label">
                                    {convertHtmlToReactDomWithParams(qwertysLabel)}
                                </span>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <span className="upTo">
                                    {isMultiDiscount && `${i18nPartner.jusqua} `}
                                </span>
                                <span>
                                    <span className="value">
                                        {displayableCashback(percent, fixed)}
                                    </span>
                                </span>
                            </React.Fragment>
                        )}
                    </div>
                );
            }

            return (
                <div className="cashback">
                    <span className="upTo">{isMultiDiscount && `${i18nPartner.jusqua} `}</span>
                    <span>
                        <span className="value">
                            {displayableCashback(percent, fixed)}{' '}
                            {isEbon ? i18nPartner.offert : i18nPartner.rembourse}
                            {(percent > 1 || fixed > 1) && 's'}
                        </span>
                    </span>{' '}
                    <span className="discount-label">
                        {label || (
                            <span>
                                {isEbon
                                    ? i18nPartner.EBON_DISCOUNT_LABEL
                                    : i18nPartner.DEFAULT_DISCOUNT_LABEL}
                                &nbsp;
                                {initialCashback && (
                                    <span className="olieu grey">
                                        &nbsp;
                                        {i18nPartner.aulieude} {initialCashback}
                                    </span>
                                )}
                            </span>
                        )}
                    </span>
                </div>
            );
        } else {
            return <div className="cashback">{i18nPartner.pasdecashbackencemoment}</div>;
        }
    };

    // render the estimated date validation block
    renderEstimatedValidationDate = () => {
        const { partner, i18nPage, isEbon, isQwertys, isOffline } = this.props;

        if (isEbon || isQwertys || isOffline) return null;

        const validationDelay = partner ? partner.validationDelay : DELAI_VALIDATION_DEFAULT;
        const isValidationAfterServiceConsumption =
            partner && partner.validationAfterServiceConsumption;
        const estimatedValidationDate = moment()
            .add(validationDelay, 'days')
            .format(MOMENTJS_DATE_FORMAT);

        return partner && partner.validationDelay > -1 && hasCashback(partner) ? (
            <div className="validation-date">
                {`${i18nPage.ESTIMATED_VALIDATION_DATE} `}
                <br className="show-mobonly" />
                <span>
                    {isValidationAfterServiceConsumption
                        ? i18nPage.VALIDATION_AFTER_SERVICE_CONSUMPTION
                        : estimatedValidationDate}
                </span>
            </div>
        ) : null;
    };

    renderCTAButton = () => {
        const { isOffline, isEbon, isQwertys, partner, i18nPage } = this.props;
        const url = getInstertitielCashbackUrl(partner);

        if (!isEbon && !isOffline && partner) {
            const buttonText = hasCashback(partner)
                ? i18nPage.TAKETHEOFFER
                : i18nPage.TAKETHEOFFER_NO_CASHBACK;

            if (isQwertys && partner.qwertysLink) {
                return (
                    <a
                        className="bt bt-main"
                        href={partner.qwertysLink}
                        title={buttonText}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={this.guardLimitedClick}>
                        {buttonText}
                    </a>
                );
            }

            return (
                <LinkButtonComponent
                    color="main"
                    text={buttonText}
                    title={buttonText}
                    to={url}
                    target="_blank"
                    onClick={this.guardOfferClick}
                />
            );
        }
        if (isOffline && partner) {
            return (
                <React.Fragment>
                    <div className="border-container">
                        <SvgComponent
                            src={`${STATIC_ROOT}/green-check.svg`}
                            width="25"
                            height="18"
                        />
                        <span>{i18nPage.REFUND_ACTIVATED}</span>
                    </div>
                    <div className="container">
                        <SvgComponent src={`${STATIC_ROOT}/carte.svg`} width="64" height="64" />
                        <span>{convertHtmlToReactDomWithParams(i18nPage.TRACKING_PURCHASE)}</span>
                    </div>
                </React.Fragment>
            );
        }

        return null;
    };

    render() {
        const {
            id,
            partner,
            partnerName,
            isEbon,
            isOffline,
            isQwertys,
            isCouponsOnly,
            isAuthenticated,
            ebonPartner,
            firstCoupon,
            i18n
        } = this.props;
        const currentPartner = isEbon ? ebonPartner : partner;

        // codes promo seuls : le premier code promo remplace l'accroche et le CTA cashback
        if (isCouponsOnly) {
            return (
                <PartnerBlockHorizontalComponent
                    partner={currentPartner}
                    noLogoLink
                    cssClass="fm-entete fm-entete-coupons-only">
                    <div className="fm-entete-offre-bt fm-entete-coupon">
                        {firstCoupon && (
                            <CouponComponent
                                coupon={firstCoupon}
                                i18n={i18n}
                                partnerId={id}
                                partnerName={partnerName}
                                isAuthenticated={isAuthenticated}
                                noPicto
                            />
                        )}
                    </div>
                </PartnerBlockHorizontalComponent>
            );
        }

        return (
            <PartnerBlockHorizontalComponent
                partner={currentPartner}
                noLogoLink
                cssClass="fm-entete">
                <div className="fm-entete-offre-bt grid has-gutter flex-center-alt">
                    <div className="fm-entete-offre">
                        {this.renderCashback()}
                        {this.renderEstimatedValidationDate()}
                        {!isEbon && !isOffline && !isQwertys && this.renderOnlineEbonCumulable()}
                        {isEbon && ebonPartner && ebonPartner.ebonDiscount && (
                            <React.Fragment>
                                <p className="availabilityType">
                                    {this.getAvailability(ebonPartner.ebonDiscount)}
                                </p>
                                {this.renderEbonCashbackCumulable()}
                            </React.Fragment>
                        )}
                    </div>
                    {!isEbon && (
                        <div className="fm-entete-bt flex-container-v">
                            {this.renderCTAButton()}
                        </div>
                    )}
                </div>
            </PartnerBlockHorizontalComponent>
        );
    }
}

HeaderComponent.propTypes = {
    id: PropTypes.string.isRequired,
    partnerName: PropTypes.string,
    isAuthenticated: PropTypes.bool.isRequired,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    isQwertys: PropTypes.bool,
    isCouponsOnly: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
    const partner = getPartner(state, ownProps.id);
    const ebonPartner = getEbonPartner(state, Number(ownProps.id));
    const isEbon = ownProps.isEbon;

    return {
        partner,
        ebonPartner,
        i18nPartner: state.i18n.feature.partenaire,
        i18nPage: state.i18n.page.MERCHANTCARD,
        isAuthenticated: state.authentication.isAuthenticated,
        isLimited: isLimitedMember(state),
        discounts: !isEbon ? toArray(state.discount.discounts[partner.id]) : null,
        i18n: state.i18n,
        firstCoupon: (getCoupons(state, ownProps.id) || [])[0] || null
    };
};

const mapDispatchToProps = {
    showModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderComponent));



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/HeaderComponent.js